import React from 'react';

export const tooltipRender = (valueField: string) => (params: any) => (<div title={params[valueField]}>{params[valueField]}</div>);